import { render, staticRenderFns } from "./ReserveTable.vue?vue&type=template&id=2c830fe0&scoped=true"
import script from "./ReserveTable.vue?vue&type=script&lang=js"
export * from "./ReserveTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c830fe0",
  null
  
)

export default component.exports